<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <section>
      <div class="card">
        <!--ricerca -->
        <div class="card-title pt-2 px-2 w-100">
          <div class="row">
            <div class="col-lg-3 col-12">
              <input type="search" id="keyword" [placeholder]="'SEARCH' | translate" class="form-control" autocomplete="off" [(ngModel)]="searchKey" (ngModelChange)="search()" />
            </div>
            <div class="col-lg-9 text-right" [ngClass.sm]="'mt-1'">
              <div [ngClass.xl]="'d-inline-block mr-2'" [ngClass.sm]="'d-none'" *ngIf="_utilService.isDesktop">
                <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
              </div>
              <a (click)="showModalAdd()" class="btn btn-outline-primary text-primary" has_capability="create_customer_referent">{{ "ADD" | translate }}</a>
            </div>
          </div>
        </div>
        <div class="card-body p-0">
          <ngx-datatable
            class="bootstrap core-bootstrap"
            columnMode="force"
            [headerHeight]="30"
            [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
            [scrollbarH]="true"
            [rowHeight]="_utilService.isDesktop ? 70 : 200"
            [limit]="tableLimit"
            [footerHeight]="50"
            [rows]="filteredReference"
            [sorts]="[
              { prop: 'client.name', dir: 'asc' },
              { prop: 'addresses[0].label', dir: 'asc' },
              { prop: 'lastname', dir: 'asc' }
            ]"
          >
            <ngx-datatable-column [name]="'COMPANY' | translate" prop="client.name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex align-items-center">
                  <img #image (error)="image.hidden = true" src="{{ row.client.logo }}" class="mr-1 rounded-circle contain" width="32" height="32" [alt]="row.client.name" />
                  <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                    <div class="avatar-content text-uppercase">{{ row?.client?.business_name[0] }}</div>
                  </div>
                  <a routerLink="/dashboard/customer/edit/{{ row.client_id }}">{{ row.client.name }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'OFFICE_SITE' | translate" prop="address_name" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a routerLink="/dashboard/list-location/edit/{{ row.addresses[0].id }}" *ngIf="row.addresses.length > 0">{{ row.addresses[0].label }}</a>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="firstname" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div>
                  <a (click)="openEditModal(row)" class="text-primary">{{ row.firstname }} {{ row.lastname }}</a>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'EMAIL' | translate" prop="email" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a href="mailto:{{ row.email }}" *ngIf="row.email">
                  <div>{{ row.email }}</div>
                </a>
                <div *ngIf="!row.email">-</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'TELEPHONE' | translate" prop="phone" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <a href="tel:{{ row.phone }}" *ngIf="row.phone">
                  <div>{{ row.phone }}</div>
                </a>
                <div *ngIf="!row.phone">-</div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false" *ngIf="_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="d-flex">
                  <button (click)="openEditModal(row)" class="bg-transparent border-0 text-secondary pr-1" has_capability="edit_customer_referent">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button class="bg-transparent border-0 text-danger remove-item" (click)="delete(row)" has_capability="delete_customer_referent">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <!--mobile - tablet-->
            <ngx-datatable-column [name]="'FIRSTNAME_AND_LASTNAME' | translate" prop="firstname" *ngIf="!_utilService.isDesktop">
              <ng-template ngx-datatable-cell-template let-row="row">
                <div class="row list-item-mobile">
                  <div class="col-10">
                    <div class="d-flex align-items-center my-025">
                      <img #image (error)="image.hidden = true" src="{{ row.client.logo }}" class="mr-1 rounded-circle" width="32" height="32" [alt]="row.client.name" />
                      <div class="avatar bg-light-secondary mr-1 ml-0" *ngIf="image.hidden">
                        <div class="avatar-content text-uppercase">{{ row?.client?.business_name[0] }}</div>
                      </div>
                      <a routerLink="/dashboard/customer/edit/{{ row.client_id }}">{{ row.client.name }}</a>
                    </div>
                    <a routerLink="/dashboard/list-location/edit/{{ row.addresses[0].id }}" *ngIf="row.addresses.length > 0">{{ row.addresses[0].label }} </a>
                    <div>
                      <a (click)="openEditModal(row)" class="text-primary">{{ row.firstname }} {{ row.lastname }}</a>
                    </div>
                    <div *ngIf="row.email">{{ row.email }}</div>
                    <div class="my-025" *ngIf="row.phone">{{ row.phone }}</div>
                  </div>
                  <div class="col-2 d-flex flex-column justify-content-center pl-0">
                    <button class="bg-transparent border-0 text-secondary mb-1" has_capability="edit_customer_referent" (click)="openEditModal(row)">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </button>
                    <button class="bg-transparent border-0 text-danger remove-item" has_capability="delete_customer_referent" (click)="delete(row)">
                      <i [data-feather]="'trash-2'" size="19"></i>
                    </button>
                  </div>
                </div>
              </ng-template>
            </ngx-datatable-column>
          </ngx-datatable>
        </div>
      </div>
    </section>
  </div>
</div>

<!-- Modal ADD -->
<ng-container has_capability="create_customer_referent" *ngIf="toggleModalAdd">
  <app-form-add-customer-referent (callbackFn)="toggleModalAdd = false" (onAdd)="onReferentModalFormEvent()"></app-form-add-customer-referent>
</ng-container>
<!-- / Modal ADD -->

<!-- Modal EDIT -->
<ng-container has_capability="edit_customer_referent" *ngIf="currentReferent !== null">
  <app-form-edit-customer-referent [selectedReferent]="currentReferent" (callbackFn)="currentReferent = null" (onEdit)="onReferentModalFormEvent()"></app-form-edit-customer-referent>
</ng-container>
<!-- / Modal EDIT -->
